<template>
    <!--<bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
          <component  :is="currentTab" :currentTab='currentTab'></component>
    </bsp-tabs>-->

  <el-tabs v-model="activeName">
    <el-tab-pane name="first"  label="租户级" lazy="true">
      <component is="TenantParameterTable" :currentTab="tenantTab"></component>
    </el-tab-pane>
    <el-tab-pane v-if="this.role.tenantId=='sys'" name="second" label="系统级" lazy="true">
      <component is="SysParameterTable" :currentTab="sysTab"></component>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
 import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
 import SysParameterTable from "@/views/sys/parameter/SysParameter";
 import TenantParameterTable from "@/views/sys/parameter/TenantParameter"
  export default {

    created() {
    },
    data() {
      return {
        role: {    
          tenantId: 'sys',
          name: 'admin'
        },
        activeName:'first', //默认激活第二个
        sysTab: 'sys',
        tenantTab: 'tenant'
      }
    },
    components:{
        SysParameterTable,
        TenantParameterTable,
    },
    methods: {
      changeTab(tab, event) {
          this.currentTab = tab.name;
      }
    }
  }
</script>
